import { GlobalService } from '@/context'
import { VersionUpdateInfos } from './type'

/**
 * 获取版本更新数据
 */
export const apiVersionUpdateList = () =>
  GlobalService.get<Array<VersionUpdateInfos>>({
    url: '/api/lobby/versionUpdate/getVersionList',
    customParams: {
      cacheExpiredOnReload: false,
      cache: true
    }
  })
